import { AlertTitle, VStack, CloseButton } from '@chakra-ui/react';
import { Alert, AlertIcon, AlertDescription } from '@/components/v4';

const Warning = (props) => {
    const { warning, style, onDismiss } = props;

    return (
        <Alert status="warning" style={style}>
            <AlertIcon />
            <VStack align="start" spacing={0} flex="1">
                <AlertTitle>{warning?.name || 'Warning'}</AlertTitle>
                <AlertDescription>
                    {warning?.message || 'WARNING'}
                </AlertDescription>
            </VStack>
            {onDismiss && (
                <CloseButton
                    alignSelf="flex-start"
                    position="relative"
                    right={-1}
                    top={-1}
                    onClick={onDismiss}
                />
            )}
        </Alert>
    );
};

export default Warning;
